export default {
	// 用户浏览记录
	tagNavList: {
		defaultVal: [], // 默认值
		expire: 0, // 到期时间/s，0=永久
		query: false, // 是否区分查询字符串
		user: true, // 是否区分用户
	},
}
